import { render } from "./LoadingWidget.vue?vue&type=template&id=91242de8"
import script from "./LoadingWidget.vue?vue&type=script&lang=js"
export * from "./LoadingWidget.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__